import React from "react";
import moment from "moment-timezone";
import get from "lodash/get";
import assign from "lodash/assign";
import merge from "lodash/merge";
import { Link } from "react-router";
import {
  ListItem,
  RaisedButton,
  TextField,
  FontIcon,
  Dialog,
  FlatButton,
  IconMenu,
  MenuItem
} from "material-ui";
import { colors as Colors } from "material-ui/styles";
import withWidth from "material-ui/utils/withWidth";
import { CopyToClipboard } from "react-copy-to-clipboard";

import PassActions from "../../../actions/PassActions";
import PersonStore from "../../../stores/PersonStore";
import GlobalNotificationActions from "../../../actions/GlobalNotificationActions";

import config from "../../../config";
import * as util from "../../../util";
import BaseOverlay from "../../overlays/base.jsx";
import SupplementaryDataEditor from "../supplementary-data-editor.jsx";
import TenantIcon from "../icons/tenant-icon.jsx";
import LinkLike from "../link-like.jsx";

class PassListItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isSaved: false,
      isEditing: false,
      isLoading: false,
      updatedName: null,

      // Supplementary data
      updatedData: {},
      supplementaryDataDialogOpen: false,

      // Pass transfer
      transferDialogOpen: false,
      destinationEmail: ""
    };

    this._getIcon = this._getIcon.bind(this);

    this.editName = this.editName.bind(this);
    this.submitName = this.submitName.bind(this);

    this.editSupplementaryData = this.editSupplementaryData.bind(this);
    this._updateDataValue = this._updateDataValue.bind(this);
    this._onSupplementaryDataSubmit =
      this._onSupplementaryDataSubmit.bind(this);
    this._handleRequestSupplementaryDataClose =
      this._handleRequestSupplementaryDataClose.bind(this);

    this.transfer = this.transfer.bind(this);
    this._onTransferSubmit = this._onTransferSubmit.bind(this);
    this._handleRequestTransferClose =
      this._handleRequestTransferClose.bind(this);

    this.resendTransfer = this.resendTransfer.bind(this);
    this.cancelTransfer = this.cancelTransfer.bind(this);

    this._onGiftSubmit = this._onGiftSubmit.bind(this);

    this._makeMenu = this._makeMenu.bind(this);
    this._makeRightIcon = this._makeRightIcon.bind(this);

    this.transitionToScan = this.transitionToScan.bind(this);
  }

  static get contextTypes() {
    return {
      isLarge: React.PropTypes.bool,
      router: React.PropTypes.object.isRequired,
      tenant: React.PropTypes.object,
      appSettings: React.PropTypes.object,
      muiTheme: React.PropTypes.object
    };
  }

  getStyles() {
    return {
      icon: {
        height: "50px",
        display: "block",
        verticalAlign: "middle",
        fontSize: 45,
        textAlign: "center",
        paddingTop: 20
      },
      link: {
        color: "rgba(0, 0, 0, 0.54)",
        textDecoration: "underline",
        cursor: "pointer"
      },
      editLink: {
        fontSize: 13,
        color: "rgba(0, 0, 0, 0.54)",
        textDecoration: "underline",
        cursor: "pointer"
      },
      editor: {
        marginTop: -13,
        marginBottom: -8
      },
      editButton: {
        marginLeft: 12,
        height: 32
      },
      editButtonLabel: {
        lineHeight: "32px"
      },
      textField: {
        lineHeight: "16px",
        height: 40,
        width: "60%",
        maxWidth: 250
      },
      dataNeeded: {
        color: "#fff",
        fontSize: 13,
        backgroundColor: Colors.red600,
        cursor: "pointer",
        padding: "0 2px"
      },
      renewalSettingsLink: {
        color: "rgba(0, 0, 0, 0.54)"
      },
      iconButton: {
        height: "100%",
        display: "inline-block",
        verticalAlign: -1,
        lineHeight: "36px",
        fontSize: 15
      },
      rightIcon: {
        position: "absolute",
        top: "inherit",
        right: "inherit",
        bottom: 12
      },
      rightIconLarge: {
        position: "absolute",
        top: 0,
        right: 4,
        padding: 12
      },
      qrCodeIcon: {
        marginLeft: -8,
        paddingRight: 16,
        color: this.context.tenant.invert_colors ? "#000" : "#fff"
      },
      menu: {
        maxWidth: "90vw",
        textAlign: "left"
      },
      menuItem: {
        cursor: "pointer"
      },
      listItem: {
        paddingBottom: 56
      },
      listItemLarge: {
        // noop
      },
      // dialogButton: {
      //   color: this.context.muiTheme.rawTheme.palette.primary1Color
      // },
      dialogTitle: {
        borderBottom: "none"
      },
      dialogActionsContainer: {
        borderTop: "none"
      },
      deactivatedPass: {
        textDecoration: "line-through"
      }
    };
  }

  _getIcon() {
    let styles = this.getStyles(),
      name = this.context.tenant.pass_icons[this.props.item.code];

    return name ? <TenantIcon name={name} style={styles.icon} /> : null;
  }

  editSupplementaryData() {
    let data = assign({}, this.props.item.supplementary_data);
    data.name =
      this.props.item.name === "Unnamed Pass" ? "" : this.props.item.name;

    this.setState({
      isEditing: true,
      updatedData: data,
      supplementaryDataDialogOpen: true
    });
  }

  _updateDataValue(key, value) {
    let data = assign({}, this.state.updatedData);
    data[key] = value;
    this.setState({
      updatedData: data
    });
  }

  _onSupplementaryDataSubmit() {
    this.setState({
      isLoading: true
    });
    this._lastUpdatedAt = this.props.item.updated_at;

    let data = assign({}, this.state.updatedData);
    let name = data.name;
    delete data.name;

    PassActions.editPass(this.props.item.id, {
      name: name,
      supplementary_data: data
    });
  }

  _handleRequestSupplementaryDataClose() {
    this.setState({
      isEditing: false,
      supplementaryDataDialogOpen: false
    });
  }

  transfer() {
    this.setState(
      {
        transferDialogOpen: true
      },
      () => {
        setTimeout(() => {
          this.transferEmail && this.transferEmail.focus();
        }, 500);
      }
    );
  }

  _onTransferSubmit() {
    this.setState({
      isLoading: true
    });
    this._lastUpdatedAt = this.props.item.updated_at;

    PassActions.transferPass(this.props.item.id, this.state.destinationEmail);
  }

  _handleRequestTransferClose() {
    this.setState({
      transferDialogOpen: false
    });
  }

  resendTransfer() {
    PassActions.resendPassTransfer(this.props.item.id);
  }

  cancelTransfer() {
    PassActions.cancelPassTransfer(this.props.item.id);
  }

  _onGiftSubmit() {
    this.setState({
      isLoading: true
    });
    this._lastUpdatedAt = this.props.item.updated_at;

    PassActions.sendGiftPass(this.props.item.id, {
      email: this.state.updatedData.email,
      message: this.state.updatedData.message
    });
  }

  editName() {
    this.setState({
      isEditing: true,
      updatedName:
        this.props.item.name !== "Unnamed Pass" ? this.props.item.name : ""
    });
  }

  submitName() {
    this.setState({
      isLoading: true
    });

    this._lastUpdatedAt = this.props.item.updated_at;

    PassActions.editPass(this.props.item.id, {
      name: this.state.updatedName
    });
  }

  componentWillReceiveProps(newProps) {
    if (
      newProps.initalEditing &&
      !this.state.isSaved &&
      !this.state.updatedName
    ) {
      this.editName();
    }

    // Assume updated pass
    if (
      this.state.isLoading &&
      newProps.item.updated_at !== this._lastUpdatedAt
    ) {
      this.setState({
        isSaved: true,
        isEditing: false,
        isLoading: false,
        supplementaryDataDialogOpen: false,
        transferDialogOpen: false
      });
    }
  }

  transitionToScan() {
    this.context.router.push(
      `/${this.context.tenant.passes_url_pathname}/${this.props.item.id}`
    );
  }

  _makeMenu(iconButtonElement) {
    let styles = this.getStyles();

    const display_pass_or_membership = this.props.item.pass_bucket.is_membership ? this.context.tenant.display_membership : this.context.tenant.display_pass

    return (
      <IconMenu
        iconButtonElement={iconButtonElement}
        menuStyle={styles.menu}
        desktop={this.context.isLarge}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        targetOrigin={{ vertical: "top", horizontal: "right" }}
      >
        {this.props.item.pending_gift_claim_url ? (
          <MenuItem
            style={styles.menuItem}
            key="pending"
            disabled={true}
            primaryText={`This ${display_pass_or_membership} will be removed from your account once the gift is accepted.`}
          />
        ) : (
          (this.props.item.pending_transfer_recipient
            ? [
                <MenuItem
                  style={styles.menuItem}
                  key="pendingtransfer"
                  disabled={true}
                  onClick={this.transfer}
                  primaryText={`Transfer to "${this.props.item.pending_transfer_recipient}" pending`}
                />,
                <MenuItem
                  style={styles.menuItem}
                  key="resendtransfer"
                  onClick={this.resendTransfer}
                  primaryText={`Resend ${display_pass_or_membership} transfer email`}
                />,
                <MenuItem
                  style={styles.menuItem}
                  key="canceltransfer"
                  onClick={this.cancelTransfer}
                  primaryText={`Cancel ${display_pass_or_membership} transfer`}
                />
              ]
            : [
                <MenuItem
                  style={styles.menuItem}
                  key="transfer"
                  onClick={this.transfer}
                  primaryText={`Transfer ${display_pass_or_membership}...`}
                />
              ]
          ).concat(
            this.props.item.pass_subscription && !this.props.hideSettingsLink
              ? [
                  <MenuItem
                    style={styles.menuItem}
                    key="renewal"
                    onClick={() => this.context.router.push("/subscriptions")}
                    primaryText={`Renewal settings`}
                  />
                ]
              : []
          )
        )}
      </IconMenu>
    );
  }

  _makeRightIcon() {
    let styles = this.getStyles(),
      pass = this.props.item,
      { isLarge } = this.context;

    if (pass.is_active === false) {
      return (
        <div style={isLarge ? styles.rightIconLarge : styles.rightIcon}>
          <RaisedButton
            label="Deactivated by organizer"
            primary={true}
            disabled={true}
          />
        </div>
      );
    }

    const manageButton = (
      <FlatButton
        style={{
          border: "1px solid",
          lineHeight: "33px"
        }}
        label={
          <span style={{ verticalAlign: 3 }}>
            <span
              className="icon-cog"
              style={{ verticalAlign: -1, marginRight: 5 }}
            ></span>
            Manage
          </span>
        }
      />
    );

    if (this.props.item.pending_gift_claim_url) {
      return (
        <div style={isLarge ? styles.rightIconLarge : styles.rightIcon}>
          <RaisedButton
            label="Pending gift"
            primary={true}
            disabled={true}
            style={{ marginRight: 12 }}
          />
          {this._makeMenu(manageButton)}
        </div>
      );
    }

    return (
      <div style={isLarge ? styles.rightIconLarge : styles.rightIcon}>
        {!pass.barcode_hidden ? (
          <RaisedButton
            label="Show QR code"
            primary={true}
            labelPosition="before"
            onClick={this.transitionToScan}
            style={{ marginRight: 12 }}
          >
            <FontIcon
              className="icon-qrcode"
              style={merge({}, styles.iconButton, styles.qrCodeIcon)}
            />
          </RaisedButton>
        ) : null}
        {this._makeMenu(manageButton)}
      </div>
    );
  }

  render() {
    var pass = this.props.item,
      nUses =
        (pass.uses ? pass.uses.length : 0) +
        (pass.uses_passes ? pass.uses_passes.length : 0),
      maxUses =
        get(pass, "pass_bucket.rules[0].restrictions.uses.total", null) || "∞",
      styles = this.getStyles(),
      { isLarge } = this.context;

    if (pass.preview_available_ticket_uses && pass.preview_available_ticket_uses.total !== "∞") {
      maxUses = pass.preview_available_ticket_uses.total;
      nUses = maxUses - pass.preview_available_ticket_uses.remaining;
    }

    const display_pass_or_membership = pass.pass_bucket.is_membership ? this.context.tenant.display_membership : this.context.tenant.display_pass;

    var bodyContent;

    if (pass.pending_gift_claim_url) {
      bodyContent = (
        <div>
          <BaseOverlay
            zIndex={2001}
            useMuiDefaultStyle={true}
            contentStyle={{ maxWidth: 400, zIndex: 3000 }}
            titleStyle={styles.dialogTitle}
            actionsContainerStyle={styles.dialogActionsContainer}
            title={`Send gift ${display_pass_or_membership}`}
            open={this.state.supplementaryDataDialogOpen}
            actions={[
              <FlatButton
                style={styles.dialogButton}
                label="Cancel"
                disabled={this.state.isLoading}
                onClick={this._handleRequestSupplementaryDataClose}
              />,
              <FlatButton
                style={styles.dialogButton}
                label={
                  this.state.isLoading ? "Sending..." : "Send gift certificate"
                }
                disabled={this.state.isLoading}
                onClick={this._onGiftSubmit}
              />
            ]}
            onRequestClose={this._handleRequestSupplementaryDataClose}
          >
            Choose a recipient and enter an optional message, then click "Send".
            <TextField
              floatingLabelText="Recipient email address"
              floatingLabelFixed={true}
              autoFocus={true}
              value={this.state.updatedData.email}
              onChange={e => this._updateDataValue("email", e.target.value)}
            />
            <TextField
              floatingLabelText="Optional message"
              floatingLabelFixed={true}
              multiLine={true}
              rows={2}
              style={{ display: "block" }}
              value={this.state.updatedData.message}
              onChange={e => this._updateDataValue("message", e.target.value)}
            />
          </BaseOverlay>
          <ListItem
            secondaryText={
              <p>
                {`${pass.display_code} | Not yet claimed`}
                {pass.pending_transfer_recipient
                  ? `, last sent to ${pass.pending_transfer_recipient}`
                  : ""}
                <br />
                <a
                  style={styles.link}
                  target="_blank"
                  href={`${config.endpoint}passes/${pass.id}/gift_certificate.pdf`}
                >
                  Download gift certificate
                </a>{" "}
                |&nbsp;
                <LinkLike
                  style={styles.link}
                  onClick={this.editSupplementaryData}
                >
                  Send to recipient
                </LinkLike>{" "}
                |&nbsp;
                <CopyToClipboard
                  text={pass.pending_gift_claim_url}
                  onCopy={() =>
                    GlobalNotificationActions.notify.defer(
                      "Gift claim link has been copied to clipboard."
                    )
                  }
                >
                  <LinkLike style={styles.link}>Copy claim link</LinkLike>
                </CopyToClipboard>
              </p>
            }
            leftIcon={this._getIcon()}
            rightIconButton={
              this.props.hideActions ? null : this._makeRightIcon()
            }
            secondaryTextLines={2}
            disabled={true}
            style={
              !this.props.hideActions &&
              (isLarge ? styles.listItemLarge : styles.listItem)
            }
            primaryText={<div>Gift {pass.pass_bucket.name}</div>}
          />
        </div>
      );
    } else if (pass.needed_supplementary_data && pass.is_active !== false) {
      // Needed since with supplementary data the edit link opens the supplementary data editor,
      // not the inline pass name editor.
      var neededData = pass.needed_supplementary_data.slice();

      const nameRequired = !this.context.tenant.sundance_login; // Sundance passes don't allow editing name

      if (nameRequired) {
        neededData.splice(0, 0, {
          key: "name",
          required: true,
          label: `Full name to display on ${display_pass_or_membership}`
        });
      }

      var statusText = `Activated ${moment(pass.created_at).format("LL")}`;
      if (pass.pass_subscription) {
        statusText += ` | ${util.formatSubscriptionStatus(
          pass.pass_subscription
        )}`;
      }
      var status = (
        <span>
          {statusText}{" "}
          {pass.pass_subscription && !this.props.hideSettingsLink ? (
            <Link style={styles.renewalSettingsLink} to="/subscriptions">
              (renewal settings)
            </Link>
          ) : null}
        </span>
      );

      bodyContent = (
        <div>
          <BaseOverlay
            zIndex={2001}
            useMuiDefaultStyle={true}
            titleStyle={styles.dialogTitle}
            actionsContainerStyle={styles.dialogActionsContainer}
            title={`${util.capitalize(
              display_pass_or_membership
            )} information`}
            open={this.state.supplementaryDataDialogOpen}
            actions={[
              <FlatButton
                style={styles.dialogButton}
                label="Cancel"
                disabled={this.state.isLoading}
                onClick={this._handleRequestSupplementaryDataClose}
              />,
              <FlatButton
                style={styles.dialogButton}
                label={this.state.isLoading ? "Submitting..." : "Submit"}
                disabled={this.state.isLoading}
                onClick={this._onSupplementaryDataSubmit}
              />
            ]}
            onRequestClose={this._handleRequestSupplementaryDataClose}
          >
            <SupplementaryDataEditor
              fields={neededData}
              data={this.state.updatedData}
              existingImages={
                (PersonStore.getPersonDetails() || {}).supplementary_data_images
              }
              updateDataValue={this._updateDataValue}
            />
          </BaseOverlay>
          <ListItem
            secondaryText={
              <p>
                {`${pass.display_code} | ${nUses}/${maxUses} use${
                  maxUses === 1 ? "" : "s"
                }`}
                <br />
                {pass.pending_transfer_recipient
                  ? `Pending transfer to ${pass.pending_transfer_recipient} | `
                  : null}
                {status}
              </p>
            }
            leftIcon={this._getIcon()}
            rightIconButton={
              this.props.hideActions ? null : this._makeRightIcon()
            }
            secondaryTextLines={2}
            disabled={true}
            style={
              !this.props.hideActions &&
              (isLarge ? styles.listItemLarge : styles.listItem)
            }
            primaryText={
              <div
                style={pass.is_active === false ? styles.deactivatedPass : {}}
              >
                {!pass.name || pass.name === "Unnamed Pass"
                  ? `Unnamed ${util.capitalize(
                      display_pass_or_membership
                    )}`
                  : pass.name}{" "}
                {!this.context.tenant.sundance_login && <a style={styles.editLink} onClick={this.editSupplementaryData}>
                  edit details
                </a>}
                &nbsp;
                {pass.needs_supplementary_data && !this.context.tenant.sundance_login ? (
                  <a
                    onClick={this.editSupplementaryData}
                    style={styles.dataNeeded}
                  >
                    details needed!
                  </a>
                ) : null}
              </div>
            }
          />
        </div>
      );
    } else {
      bodyContent = (
        <ListItem
          secondaryText={
            <p>
              {`${pass.display_code} | ${nUses}/${maxUses} use${
                maxUses === 1 ? "" : "s"
              }`}
              <br />
              {pass.pending_transfer_recipient
                ? `Pending transfer to ${pass.pending_transfer_recipient} | `
                : null}
              {`Activated ${moment(pass.created_at).format("LL")}`}
            </p>
          }
          leftIcon={this._getIcon()}
          rightIconButton={
            this.props.hideActions ? null : this._makeRightIcon()
          }
          secondaryTextLines={2}
          disabled={true}
          style={
            !this.props.hideActions &&
            (isLarge ? styles.listItemLarge : styles.listItem)
          }
          primaryText={
            this.state.isEditing ? (
              <div style={styles.editor}>
                <TextField
                  disabled={this.state.isLoading}
                  style={styles.textField}
                  onKeyDown={e => {
                    if (e.keyCode === 13) this.submitName();
                  }}
                  placeholder="First & Last Name"
                  value={this.state.updatedName}
                  onChange={e => this.setState({ updatedName: e.target.value })}
                />
                <RaisedButton
                  label={this.state.isLoading ? "Saving..." : "Save name"}
                  primary={true}
                  disabled={this.state.isLoading || !this.state.updatedName}
                  style={styles.editButton}
                  labelStyle={styles.editButtonLabel}
                  onClick={this.submitName}
                />
              </div>
            ) : (
              <div
                style={pass.is_active === false ? styles.deactivatedPass : {}}
              >
                {pass.name}{" "}
                {pass.is_active !== false &&
                !this.context.tenant.sundance_login ? (
                  <a style={styles.editLink} onClick={this.editName}>
                    edit {display_pass_or_membership} name
                  </a>
                ) : null}
              </div>
            )
          }
        />
      );
    }

    return (
      <div>
        <Dialog
          titleStyle={styles.dialogTitle}
          actionsContainerStyle={styles.dialogActionsContainer}
          title={`Transfer ${display_pass_or_membership}`}
          open={this.state.transferDialogOpen}
          className="Eventive--Dialog Eventive--Dialog--PassTransfer"
          actions={[
            <FlatButton
              style={styles.dialogButton}
              label="Cancel"
              disabled={this.state.isLoading}
              onClick={this._handleRequestTransferClose}
            />,
            this.context.appSettings.passholder_transfer_allowed && (
              <FlatButton
                style={styles.dialogButton}
                label="Submit"
                disabled={this.state.isLoading}
                onClick={this._onTransferSubmit}
              />
            )
          ]}
          autoScrollBodyContent={true}
          onRequestClose={this._handleRequestTransferClose}
        >
          {this.context.appSettings.passholder_transfer_allowed ? (
            <div>
              <p>
                You can transfer this {display_pass_or_membership} to
                anyone with an email address. Once you submit this form, they
                will receive a link that will allow them to accept the transfer
                and add the {display_pass_or_membership} to their account.
                Until they accept the transfer, the{" "}
                {display_pass_or_membership} will remain in your account.
                Once they accept, the pass will permanently disappear from your
                account unless the recipient transfers it back to you.
              </p>
              <p>
                <strong>
                  Note: {util.capitalize(display_pass_or_membership)}{" "}
                  transfers do not transfer existing tickets.
                </strong>
              </p>
              <TextField
                ref={r => {
                  this.transferEmail = r;
                }}
                disabled={this.state.isLoading}
                type="email"
                floatingLabelText="Recipient email address"
                floatingLabelFixed={true}
                value={this.state.destinationEmail}
                onChange={e =>
                  this.setState({ destinationEmail: e.target.value })
                }
              />
            </div>
          ) : (
            <div>
              <p>
                {util.capitalize(display_pass_or_membership)} transfers
                are not enabled. Please contact the event organizer for more
                information.
              </p>
            </div>
          )}
        </Dialog>
        {bodyContent}
      </div>
    );
  }
}

export default withWidth()(PassListItem);



// WEBPACK FOOTER //
// ./src/app/components/partials/pass-list/pass-list-item.jsx